import React from 'react'

import { Helmet } from 'react-helmet'

import SolidButton from '../components/solid-button'
import PlaceCard from '../components/place-card'
import './landing-page.css'
import GreenBayImage from '../assets/images/grenn-bay.jpg'
import BuiTramImage from '../assets/images/bui-tram.jpg'
import CitaDineImage from '../assets/images/CITADIN.jpg'
import PhuLamImage from '../assets/images/phu-Lam.jpg'
import TrucAnVienImage from '../assets/images/truc-an-vien.jpg'
//import bgImage from '../assets/images/img_bg_4.jpg';
import qrImage from "../assets/images/myhome_qr_download.jpg";
import appleStore from "../assets/images/apple-store.svg";
import googlePlay from "../assets/images/google-play.svg";

const LandingPage = (props) => {
  const handleExploreClick = () => {
    // Example: Smooth scroll to the main content section
    const mainContent = document.getElementById("main-section");
    if (mainContent) {
      mainContent.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="landing-page-container1">
      <Helmet>
        <title>My Home</title>
        <meta property="og:title" content="Travel Agency" />
      </Helmet>
      <div className="landing-page-top-container"
           // style={{backgroundImage: `url(${bgImage})`,}}
      >
        <nav data-role="Header" className="landing-page-navbar">
          <h1>MyHome</h1>
          <div className="landing-page-right-side1">
            <div className="landing-page-links-container1">
              <span className="landing-page-text10">Home</span>
              <span className="landing-page-text11">About</span>
              {/*<span className="landing-page-text12">Tour Packages</span>*/}
              <span className="landing-page-text13">Contact</span>
            </div>
            {/*<a href="#main-section" className="landing-page-link10">*/}
            {/*  <SolidButton button="Explore places"></SolidButton>*/}
            {/*</a>*/}
          </div>
          <div data-role="BurgerMenu" className="landing-page-burger-menu1">
            <svg viewBox="0 0 1024 1024" className="landing-page-burger-menu2">
              <path d="M810.667 725.333h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
              <path d="M810.667 426.667h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
              <path d="M810.667 128h-597.333c-47.061 0-85.333 38.272-85.333 85.333s38.272 85.333 85.333 85.333h597.333c47.061 0 85.333-38.272 85.333-85.333s-38.272-85.333-85.333-85.333z"></path>
            </svg>
          </div>
          <div data-role="MobileMenu" className="landing-page-mobile-menu">
            <div className="landing-page-nav">
              <div className="landing-page-top">
                <h1>MYHOME</h1>
                <div
                  data-role="CloseMobileMenu"
                  className="landing-page-close-menu"
                >
                  <svg viewBox="0 0 1024 1024" className="landing-page-icon13">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              {/*<div className="landing-page-right-side2">*/}
              {/*  <div className="landing-page-links-container2">*/}
              {/*    <span className="landing-page-text14">Home</span>*/}
              {/*    <span className="landing-page-text15">About</span>*/}
              {/*    <span className="landing-page-text16">Tour Packages</span>*/}
              {/*    <span>Contact</span>*/}
              {/*  </div>*/}
              {/*  <a href="#main-section" className="landing-page-link11">*/}
              {/*    <SolidButton button="Explore places"></SolidButton>*/}
              {/*  </a>*/}
              {/*</div>*/}
            </div>
            <div className="landing-page-follow-container1">
              <span className="landing-page-text18">
                Follow us on
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <div className="landing-page-icons-container1">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="landing-page-link12"
                >
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="landing-page-icon15"
                  >
                    <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                  </svg>
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="landing-page-link13"
                >
                  <svg
                    viewBox="0 0 602.2582857142856 1024"
                    className="landing-page-icon17"
                  >
                    <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
                  </svg>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="landing-page-link14"
                >
                  <svg
                    viewBox="0 0 950.8571428571428 1024"
                    className="landing-page-icon19"
                  >
                    <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </nav>
        <div className="landing-page-hero">
          <div className="landing-page-content-container">
            <h1 className="Heading landing-page-text19">My Home</h1>
            <h2 className="Subheading landing-page-subheading">
              Ứng dụng tư vấn,<br />
              Vận hành khu nghỉ dưỡng vừa và nhỏ
            </h2>
            <span className="landing-page-text20">
              <span>

                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span></span>
            </span>
            {/*<SolidButton button="Explore homes" onClick={scrollToSection}></SolidButton>*/}
            <SolidButton
                button="Khám phá ngay"
                onClick={handleExploreClick}>
              </SolidButton>
          </div>
        </div>
      </div>
      <div id="main-section" className="landing-page-main">
        <h1><br />Các dự án đã triển khai</h1>
        <span className="landing-page-text25"></span>
        <div className="landing-page-cards-container">
          <PlaceCard
            city="GreenBay Garden Hạ Long"
            image={GreenBayImage} // Sử dụng ảnh đã import
            description="Đang vận hành"
          />
          <PlaceCard
            city="Phú Lâm FarmStay"
            image={PhuLamImage} // Sử dụng ảnh đã import
            description="Đang triển khai"
          ></PlaceCard>
          <PlaceCard
            city="CITADINE Hạ Long"
            image={CitaDineImage} // Sử dụng ảnh đã import
            description="Đang vận hành"
          ></PlaceCard>
          <PlaceCard
            city="Bùi Trám ECOVALLEY"
            image={BuiTramImage} // Sử dụng ảnh đã import
            description="Đã tư vấn"
          ></PlaceCard>
          <PlaceCard
            city="Trúc An Viên VILLAGE"
            image={TrucAnVienImage} // Sử dụng ảnh đã import
            description="Đã vận hành"
          ></PlaceCard>
          {/*<PlaceCard*/}
          {/*  city="Barcelona"*/}
          {/*  image="https://images.unsplash.com/photo-1564221710304-0b37c8b9d729?ixlib=rb-1.2.1&amp;q=85&amp;fm=jpg&amp;crop=entropy&amp;cs=srgb&amp;h=1000"*/}
          {/*  description="Đang triển khai"*/}
          {/*></PlaceCard>*/}
        </div>
      </div>
      <div className="landing-page-footer">
        <div className="landing-page-menu">
          <h1 style={{ fontSize: "36px", marginBottom: "0" }}>
            MyHome
          </h1>
          <span style={{ fontSize: "16px", display: "block", marginTop: "0" }}>

          </span>
          <div align="center" className="col-md-4">
            {/*<h4>Tải ứng dụng Myhome</h4>*/}
            <p></p>
            <ul className="colorlib-footer-links">
                <img
                    alt="Myhome"
                    width="100"
                    height="100"
                    align="center"
                    src={qrImage}
                    loading="lazy"
                />
                <a
                    target="_blank"
                    rel="nofollow noreferrer"
                    href="https://apps.apple.com/sg/app/myhome/id1476078746"
                    className="d-inline-block mb-18"
                >
                  <img
                      alt="Apple Store"
                      width="180"
                      height="56"
                      src={appleStore}
                      loading="lazy"
                  />
                </a>
                <a
                    target="_blank"
                    rel="nofollow noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.vn.myhomebooking"
                    className="d-inline-block mb-18 mb-sm-0"
                >
                  <img
                      alt="Google Play"
                      width="180"
                      height="56"
                      src={googlePlay}
                      loading="lazy"
                  />
                </a>
            </ul>
            <p></p>
          </div>
          <div className="landing-page-links-container3">

            {/*<div className="landing-page-container2">*/}
            {/*  <a*/}
            {/*    href=""*/}
            {/*    target="_blank"*/}
            {/*    rel="noreferrer noopener"*/}
            {/*    className="landing-page-link15"*/}
            {/*  >*/}
            {/*    Tour packages*/}
            {/*  </a>*/}
            {/*  <a*/}
            {/*    href=""*/}
            {/*    target="_blank"*/}
            {/*    rel="noreferrer noopener"*/}
            {/*    className="landing-page-link16"*/}
            {/*  >*/}
            {/*    Personalized offers*/}
            {/*  </a>*/}
            {/*  <a*/}
            {/*    href=""*/}
            {/*    target="_blank"*/}
            {/*    rel="noreferrer noopener"*/}
            {/*    className="landing-page-link17"*/}
            {/*  >*/}
            {/*    Special deals*/}
            {/*  </a>*/}
            {/*  <a*/}
            {/*    href=""*/}
            {/*    target="_blank"*/}
            {/*    rel="noreferrer noopener"*/}
            {/*    className="landing-page-link18"*/}
            {/*  >*/}
            {/*    Summer holiday*/}
            {/*    <span*/}
            {/*      dangerouslySetInnerHTML={{*/}
            {/*        __html: ' ',*/}
            {/*      }}*/}
            {/*    />*/}
            {/*  </a>*/}
            {/*</div>*/}
            <div className="landing-page-container3">
              <a
                href=""
                // target="_blank"
                rel="noreferrer noopener"
                className="landing-page-link19"
              >
                About us
              </a>
              <a
                href=""
                target="_blank"
                rel="noreferrer noopener"
                className="landing-page-link20"
              >
                FAQ
              </a>
              <a
                href=""
                // target="_blank"
                rel="noreferrer noopener"
                className="landing-page-link21"
              >
                Terms and conditions
              </a>
              <a
                  href="tel:0944975886"
                  className="landing-page-link22"
                  rel="noreferrer noopener"
              >
                Hotline: 0944 975 886
              </a>
            </div>
          </div>
          <div className="landing-page-follow-container2">
            <span className="landing-page-text26">
              Follow us on
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <div className="landing-page-icons-container2">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer noopener"
                className="landing-page-link23"
              >
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="landing-page-icon21"
                >
                  <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                </svg>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer noopener"
                className="landing-page-link24"
              >
                <svg
                  viewBox="0 0 602.2582857142856 1024"
                  className="landing-page-icon23"
                >
                  <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
                </svg>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer noopener"
                className="landing-page-link25"
              >
                <svg
                  viewBox="0 0 950.8571428571428 1024"
                  className="landing-page-icon25"
                >
                  <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingPage
